import { Injectable, inject } from '@angular/core';
import { PlayReportingService } from './play-reporting.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { PlaySalesforceInteraction } from '@r1-compass-library/models/reporting/reporting-data.model';
import { catchError, Observable, of, retry } from 'rxjs';
import { HttpHeaderConstants } from '@r1-compass-library/constants';
import { SalesforceInteractionSearch } from '@r1-compass-library/models/reporting/reporting-search.model';
import { AllCharacterHttpParamsEncoder } from '@r1-compass-library/utilities/AllCharacterHttpParamsEncoder';
import { Environment } from '@r1-compass-library/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class PlaySalesforceInteractionService extends PlayReportingService {
    readonly #http = inject(HttpClient);

    private SALESFORCE_INTERACTION_URL: string = Environment.baseUrl + '/frontend/play-salesforce-interactions';

    constructor() {
        super();
    }

    find(search: SalesforceInteractionSearch): Observable<PlaySalesforceInteraction[]> {
        const customHttpOptions = {
            headers: new HttpHeaders({ ...HttpHeaderConstants.defaultHeaders }),
            params: new HttpParams({
                encoder: new AllCharacterHttpParamsEncoder(),
            }),
        };
        this.addSearchParams(search, customHttpOptions);
        return this.#http.get<PlaySalesforceInteraction[]>(this.SALESFORCE_INTERACTION_URL, customHttpOptions).pipe(
            retry(0),
            catchError(() => {
                return of<PlaySalesforceInteraction[]>();
            })
        );
    }

    getJoinedAggregates(search: SalesforceInteractionSearch): Observable<object[]> {
        const customHttpOptions = {
            headers: new HttpHeaders({ ...HttpHeaderConstants.defaultHeaders }),
            params: new HttpParams({
                encoder: new AllCharacterHttpParamsEncoder(),
            }),
        };

        this.addSearchParams(search, customHttpOptions);

        return this.#http.get<object[]>(`${this.SALESFORCE_INTERACTION_URL}/joined-aggregates`, customHttpOptions).pipe(
            retry(0),
            catchError(() => {
                return of<object[]>();
            })
        );
    }
}
